const AddressTypes = {
  Permanent: 0,
  Mailing: 1,
  SubstantialOwner: 2,
  ControllingPersonMailing: 3,
  ControllingPersonPermanent: 4,
  W9Address: 5,
  Business: 6,
  BusinessEci2014: 7,
  Current: 8,
  HeadOffice: 9,
  Partner: 10,

  getDescription(type) {
    switch (type) {
      case AddressTypes.Permanent:
        return 'Permanent Address';
      case AddressTypes.Mailing:
        return 'Mailing Address';
      case AddressTypes.SubstantialOwner:
        return 'Substantial Owner Address';
      case AddressTypes.ControllingPersonMailing:
        return 'Controlling Person Mailing Address';
      case AddressTypes.ControllingPersonPermanent:
        return 'Controlling Person Permanent Address';
      case AddressTypes.W9Address:
        return 'Address';
      case AddressTypes.Business:
      case AddressTypes.BusinessEci2014:
        return 'Business Address';
      case AddressTypes.Current:
        return 'Current Residence Address';
      case AddressTypes.HeadOffice:
        return 'Head Office Address';
      case AddressTypes.Partner:
        return 'Partner Address';
      default:
        return null;
    }
  },

  hasCountry(type) { return ![AddressTypes.Business].includes(type); }
};

export default AddressTypes;
